<template>
    <transition name="fade">
        <div v-if="show" class="relative flex flex-col sm:flex-row items-center justify-between px-6 py-4 bg-blue-light border border-blue-200 shadow-md rounded-xl">
            <button class="absolute top-1 right-3 text-blue hover:text-blue-600 transition" @click="show = false">
                <i class="fi fi-rr-cross text-xs"></i>
            </button>

            <div class="flex items-center space-x-2">
                <span class="bg-blue text-white text-xs font-semibold px-2 py-0.5 rounded-full">
                    {{ $t('helpTour_portfolio_new') }}
                </span>
                <span class="text-sm font-medium text-blue-900">
                    {{ title }}
                </span>
            </div>

            <div class="mt-2 sm:mt-0 sm:ml-auto">
                <button class="px-4 py-2 mx-4 text-sm font-semibold text-white bg-blue hover:bg-blue-600 rounded-lg transition" @click="$emit('start-tutorial')">
                    {{ $t('helpTour_portfolio_tutorial') }}
                </button>
            </div>
        </div>
    </transition>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({
    title: { type: String, required: true },
    showUntil: { type: String, required: true }
});

defineEmits(['start-tutorial']);

const show = ref(new Date() < new Date(props.showUntil));
</script>
